import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class WebsocketService {
  constructor() {}

  available(): Observable<boolean> {
    const ws = new WebSocket(`${environment.webSocketUrl}/ws`);
    return new Observable<boolean>((observer) => {
      ws.onopen = () => {
        observer.next(true);
        observer.complete();
        ws.close();
      };

      ws.onerror = () => {
        observer.next(false);
        observer.complete();
      };

      return () => {
        if (ws.readyState === WebSocket.CONNECTING || ws.readyState === WebSocket.OPEN) {
          ws.close();
        }
      };
    });
  }
}
